/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, FormControl, FormErrorMessage, FormHelperText, FormLabel, Heading, HStack, PinInput, PinInputField } from '@chakra-ui/react'
import { Controller, useForm } from 'react-hook-form'
import { GoKebabHorizontal } from 'react-icons/go'
import { useNavigate, useParams } from 'react-router-dom'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { appApi } from '../../../services/appApi'

type FormCodeValues = {
  code: string
}

export const Assinatura: React.FC = () => {
  const codeForm = useForm<FormCodeValues>()
  const nav = useNavigate()
  const { documentoId } = useParams()

  async function onSubmitCode(data: FormCodeValues): Promise<void> {
    console.log(data)

    const corpoRequisicao = {
      documentoId: documentoId,
      codigo: data.code
    }

    appApi.post('api/Assinatura/validar', corpoRequisicao)
      .then((res) => {
        if (res.data.sucesso) {
          // Chave por documento: sem isso, o codigo de um assinante ja excluido ficava valendo
          // pra qualquer outro cargo/assinatura aberto depois no mesmo navegador
          localStorage.setItem(`codigo-assinatura-cargosESalarios-${documentoId ?? ''}`, corpoRequisicao.codigo)
          nav('VisualizacaoSolicitacao')
        }
      })
      .catch((error) => {
        console.error('Erro ao validar código:', error)
        alert('Código inválido.')
      })
  }

  return (
        <Box bg={'white'} flex={1} alignItems={'center'} flexDirection={'column'} display={'flex'} p={14} gap={4}>
          <Heading as="h1" size="xl">Entre com o código recebido por e-mail</Heading>
                <form noValidate onSubmit={codeForm.handleSubmit(onSubmitCode)} style={{ display: 'flex', flexDirection: 'column', gap: '3rem', width: '100%', maxWidth: '500px', marginTop: '2rem', alignItems: 'center', textAlign: 'center', justifyContent: 'center' }}>
                  <FormControl isInvalid={!!codeForm.formState.errors.code} isRequired display={'flex'} flexDirection={'column'} alignItems={'center'}>
                    <FormLabel>Insira o código</FormLabel>

                    <Controller
                      name='code'
                      control={codeForm.control}
                      rules={{
                        required: 'O código é obrigatório',
                        pattern: {
                          value: /^[A-Z0-9]{8}$/,
                          message: 'Código inválido. Deve conter 8 caracteres'
                        }
                      }}
                      render={({ field }) =>
                      <HStack spacing={4}>
                        <PinInput
                          otp
                          type="alphanumeric"
                          value={field.value?.toString() || ''}
                          onChange={(value) => field.onChange(value.toUpperCase())}
                          >
                          <PinInputField onBlur={async () => await codeForm.trigger('code')} />
                          <PinInputField onBlur={async () => await codeForm.trigger('code')} />
                          <PinInputField onBlur={async () => await codeForm.trigger('code')} />
                          <PinInputField onBlur={async () => await codeForm.trigger('code')} />
                          <PinInputField onBlur={async () => await codeForm.trigger('code')} />
                          <PinInputField onBlur={async () => await codeForm.trigger('code')} />
                          <PinInputField onBlur={async () => await codeForm.trigger('code')} />
                          <PinInputField onBlur={async () => await codeForm.trigger('code')} />
                        </PinInput>
                      </HStack>}
                    />

                    <FormHelperText fontSize={'small'} color={'gray.500'}>Insira o código de 8 dígitos recebido por e-mail <br /> Nunca compartilhe este código</FormHelperText>
                    <FormErrorMessage>{codeForm.formState.errors.code?.message}</FormErrorMessage>
                  </FormControl>

                  <ButtonCmp bgColor={'green.400'} leftIcon={<GoKebabHorizontal size={'25px'} />} h={'48px'} w={'300px'} type={'submit'} isLoading={codeForm.formState.isSubmitting}>Confirmar código</ButtonCmp>
                </form>
        </Box>
  )
}
